// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3YG7a","nav":"Header_nav__1aIH1","logo":"Header_logo__219DS","login":"Header_login__1zDMh"};